import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class FactureService {
  constructor(private httpClient: HttpClient) {}

  getData() {
    return this.httpClient.get(environment.Localurl + "facture");
  }

  insertData(data) {
    return this.httpClient.post(environment.Localurl + "facture", data);
  }

  deleteData(id) {
    return this.httpClient.delete(environment.Localurl + "facture/" + id);
  }

  getOneData(id) {
    return this.httpClient.get(environment.Localurl + "facture/" + id);
  }

  updateData(id, data) {
    return this.httpClient.put(environment.Localurl + "facture/" + id, data);
  }

  sendFactureByMail(id) {
    return this.httpClient.get(
      environment.Localurl + "sendFactureByMail/" + id
    );
  }

  sendFactureAvanceByMail(id) {
    return this.httpClient.get(
      environment.Localurl + "sendFactureAvanceByMail/" + id,{ responseType: "text" }
    );
  }
}
